import { forwardRef, useRef } from 'react'
import { Link } from 'react-router-dom'

const variants = {
    primary: 'bg-primary text-white border-primary hover:bg-opacity-90',
    secondary: 'bg-transparent text-primary border-primary hover:bg-primary/5',
    danger: 'bg-danger text-white border-danger hover:bg-opacity-90',
    outline: 'bg-transparent text-black dark:text-white border-stroke hover:bg-gray dark:hover:bg-strokedark',
}

const sizes = {
    sm: 'py-1 px-3 text-xs',
    md: 'py-2 px-6 text-sm',
    lg: 'py-3 px-8 text-base',
}

export default forwardRef(function Button({
    className = '',
    disabled,
    children,
    variant = 'primary',
    size = 'md',
    loading = false,
    ...props
}, ref) {
    const input = useRef()
    const Div = props.href ? Link : 'button'
    return (
        <Div
            {...props}
            className={`flex items-center justify-center cursor-pointer rounded-lg border transition ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${disabled || loading ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
            disabled={disabled || loading}
            ref={ref || input}
        >
            {loading ? (
                <span className="flex items-center gap-2">
                    <svg className="animate-spin size-4" viewBox="0 0 24 24" fill="none">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    {children}
                </span>
            ) : children}
        </Div>
    )
})
